import moment from "moment"

export function currentDates(state = null, action) {
	let dates
	if (action.currentDates) {
		dates = {
			start: action.currentDates.startDate,
			end: action.currentDates.endDate,
			startText: action.currentDates.startDate.format("MMMM D, YYYY"),
			endText: action.currentDates.endDate.format("MMMM D, YYYY"),
			startStamp: action.currentDates.startDate.unix(),
			endStamp: action.currentDates.endDate.unix(),
			ytd: false
		}
		if(action.currentDates.chosenLabel == 'This Year') dates.ytd = true
	} else {
		dates = state
	}

	switch (action.type) {
		case "UPDATE_DATES":
			return dates
		default:
			return state
	}
}

export function compareDates(state = null, action) {
	let dates
	if(action.compareDates === true) {
		dates = {
			start: moment().subtract(29, "days"),
			end: moment(),
			startText: moment().subtract(29, "days").format("MMMM D, YYYY"),
			endText: moment().format("MMMM D, YYYY"),
			startStamp: moment().subtract(29, "days").unix(),
			endStamp: moment().unix(),
		}
	}
	else if (action.compareDates === false || (action.compareDates && !action.compareDates.startDate)) {
		dates = {
			start: false,
			end: false,
			startText: false,
			endText: false,
			startStamp: false,
			endStamp: false,
		}
	} else if (action.compareDates) {
		dates = {
			start: action.compareDates.startDate,
			end: action.compareDates.endDate,
			startText: action.compareDates.startDate.format("MMMM D, YYYY"),
			endText: action.compareDates.endDate.format("MMMM D, YYYY"),
			startStamp: action.compareDates.startDate.unix(),
			endStamp: action.compareDates.endDate.unix(),
		}
	} else {
		dates = state
	}

	switch (action.type) {
		case "UPDATE_COMPARE_DATES":
			return dates
		default:
			return state
	}
}

export function trafficSources(state = {}, action) {
	switch (action.type) {
		case "FETCH_TRAFFICSOURCES_SUCCESS":
			return action.trafficSources

		default:
			return state
	}
}

export function overlayStatus(state = false, action) {
	switch (action.type) {
		case "UPDATE_OVERLAY":
			return action.overlayStatus
		default:
			return state
	}
}

export function loadingStatus(state = false, action) {
	switch (action.type) {
		case "UPDATE_LOADING_OVERLAY":
			return action.loadingStatus
		default:
			return state
	}
}

export function loadingStatusMessage(state = '', action) {
	switch (action.type) {
		case "UPDATE_LOADING_MESSAGE":
			return action.loadingStatusMessage
		default:
			return state
	}
}

export function compareStatus(state = null, action) {
	switch (action.type) {
		case "UPDATE_COMPARE_STATUS":
			return action.compareStatus
		default:
			return state
	}
}

export function userInfo(state = null, action) {
	switch (action.type) {
		case "STORE_USER_INFO":
			return action.payload
		default:
			return state
	}
}

export function activeProperties(state = [], action) {
	switch (action.type) {
		case "SET_ACTIVE_PROPERTIES":
			return action.payload
		default:
			return state
	}
}

export function viewAs(state = 0, action) {
	switch (action.type) {
		case "SET_VIEW_AS":
			return action.payload
		default:
			return state
	}
}

export function tableExporting(state = { active: false, data: {}, sorted: [], columns: [], title: '', paddingTop: '', raw: [] }, action) {
	switch (action.type) {
		case "SET_TABLE_EXPORTING":
			return action.payload
		default:
			return state
	}
}